/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { LevelDraft } from './levelDraft';

export interface ModuleDraftInput {
  title: string;
  description: string;
  levels: LevelDraft[];
}
